// useUserStore.js (Pinia store)
import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => ({
    fecha: '',
    estado: 'no identificado',
  }),
  actions: {
    setEstado(newEstado) {
      this.estado = newEstado; // Updates the estado reactively
    },
    setFecha(newFecha) {
      this.fecha = newFecha; // Updates the fecha reactively
    },
  },
});
